import { UiKitSectionImportantProjects } from '@/fo/ui/kit/section/important-projects';

import { importantProjectsMock } from '../mock';

import { styles } from './UiArticleSectionProjects.styles';

export function UiArticleSectionProjects() {
  const slots = styles();

  return (
    <section className={slots.base()}>
      <UiKitSectionImportantProjects
        content={importantProjectsMock}
        variant="secondary"
      />
    </section>
  );
}
